import { Ds } from "@accurx/design";
import { SkeletonLoader } from "@accurx/inbox-design-library";

export const FormLoadingState = () => (
    <Ds.Flex flexDirection="column" gap="0.25">
        <Ds.Box py="6px">
            <SkeletonLoader height="12px" width="58%" />
        </Ds.Box>
        <Ds.Box py="6px">
            <SkeletonLoader height="12px" width="91%" />
        </Ds.Box>
    </Ds.Flex>
);
